import dayjs from 'dayjs';
import {
  EventContentArg,
  AllDayContentArg,
  DayHeaderContentArg,
  CustomContentGenerator,
} from '@fullcalendar/core';

import { SelectOption } from 'components/select';

import { Event } from './event';
import * as Styles from './styles';

export const viewTypeOptions: SelectOption[] = [
  { label: 'Month', value: 'dayGridMonth' },
  { label: 'Week', value: 'timeGridWeek' },
  { label: 'Day', value: 'timeGridDay' },
];

export const dayHeaderContent: CustomContentGenerator<DayHeaderContentArg> = (
  data
) => {
  const { dow, date, view } = data;

  // The weekday comes from the column's day of week (dow): in Month view the
  // header date is a UTC midnight, so formatting it in New York read one day
  // early ("Sat" over the Sunday column).
  const weekday = dayjs().day(dow).format('ddd');
  const isMonthView = view.type === 'dayGridMonth';
  return (
    <div>
      <Styles.WeekdayLabel isMonthView={isMonthView}>
        {weekday}
      </Styles.WeekdayLabel>
      {!isMonthView && (
        <Styles.DayLabel>{dayjs(date).format('D')}</Styles.DayLabel>
      )}
    </div>
  );
};

export const eventContent: CustomContentGenerator<EventContentArg> = (data) => (
  <Event {...data} />
);

export const allDayContent: CustomContentGenerator<AllDayContentArg> = () => (
  <div style={{ minHeight: 24 }} />
);
